const pm = {
  // ==================== PLANT MAINTENANCE (Platzhalter / Modul-Kachel) ====================
  'pm.title': 'Plant Maintenance',
  'pm.subtitle': 'Manage maintenance orders, maintenance plans and technical objects',

  // ==================== PLANT-MAINTENANCE-MODUL (portiert aus i18n/*.json, Praefix pm.) ====================
  'pm.common.loading': 'Loading…',
  'pm.common.back': 'Back',
  'pm.common.next': 'Next',
  'pm.common.done': 'Done',
  'pm.common.clear': 'Clear',
  'pm.common.loadError': 'Could not load data.',
  'pm.scope.placeholder': 'Connection to the server failed — your assigned plants could not be loaded, so nothing can be created or changed until this works.',
  'pm.common.retry': 'Retry',
  'pm.header.reset': 'Reset data',
  'pm.header.resetConfirm': 'Delete all data created during testing and reset to the initial state?',
  'pm.role.mechanic': 'Mechanic',
  'pm.role.supervisor': 'Supervisor',
  'pm.role.controller': 'Controlling',
  'pm.search.placeholder': 'e.g. pump, 10004711…',
  'pm.home.title': 'What are you looking for?',
  'pm.home.subtitle': 'Equipment, order or material — just type.',
  'pm.home.actions': 'Actions',
  'pm.recent.title': 'Last used',
  'pm.home.soon': 'soon',
  'pm.home.notActive': '“{label}” is not active yet in this prototype.',
  'pm.home.resetDone': 'Demo data reset.',
  'pm.action.create-order.label': 'Create order',
  'pm.action.create-order.sub': 'In 3 steps',
  'pm.action.create-notification.label': 'Create notification',
  'pm.action.create-notification.sub': 'Problem + photo',
  'pm.action.my-orders.label': 'My orders',
  'pm.action.my-orders.sub': 'List & confirmation',
  'pm.action.material-search.label': 'Find material',
  'pm.action.material-search.sub': 'Visual search',
  'pm.action.backlog.label': 'Order backlog',
  'pm.action.backlog.sub': 'Open orders',
  'pm.action.approvals.label': 'Approvals',
  'pm.action.approvals.sub': 'Review & approve',
  'pm.order.steps.device': 'Equipment',
  'pm.order.steps.problem': 'Problem',
  'pm.order.steps.confirm': 'Confirm',
  'pm.order.whichDevice': 'Which equipment?',
  'pm.order.problemLabel': 'What\'s the problem?',
  'pm.order.problemPlaceholder': 'Describe briefly…',
  'pm.order.pastNotifications': 'Past notifications on this equipment:',
  'pm.order.priority': 'Priority',
  'pm.order.confirmTitle': 'Confirm order',
  'pm.order.fieldDevice': 'Equipment',
  'pm.order.fieldProblem': 'Problem',
  'pm.order.fieldPriority': 'Priority',
  'pm.order.fieldOrderType': 'Order type',
  'pm.order.fieldPlant': 'Plant',
  'pm.order.fieldWorkCenter': 'Work center',
  'pm.order.longTextLabel': 'Details (optional)',
  'pm.order.longTextPlaceholder': 'Detailed description — dictation goes here, no character limit.',
  'pm.order.fieldLongText': 'Details',
  'pm.order.detailsShow': 'Change details',
  'pm.order.detailsHide': 'Hide details',
  'pm.order.defaultsNote': 'Pre-filled from your profile. (Editing limited in the prototype.)',
  'pm.order.createBtn': 'Create order',
  'pm.order.creating': 'Creating…',
  'pm.order.createHint': 'Created directly in SAP',
  'pm.order.createHintMock': 'Demo mode — nothing is written to SAP',
  'pm.order.successTitle': 'Order created',
  'pm.order.orderNumber': 'Order number',
  'pm.order.duplicateNote': '(already existed — no duplicate created)',
  'pm.order.addPartsNow': 'Open order & add parts',
  'pm.order.openCreated': 'Open order',
  'pm.order.errorPrefix': 'Error',
  'pm.priority.low': 'Low',
  'pm.priority.mid': 'Medium',
  'pm.priority.high': 'High',
  'pm.priority.veryHigh': 'Very high (machine down)',
  // Order-type codes -> intent (demo customizing; per customer from sap-contract-requirements.md §6a).
  'pm.orderType.PM02': 'Maintenance',
  'pm.orderType.PM03': 'Repair',
  // SAP transparency panel (SapPayloadPanel): fields going to / coming from SAP.
  'pm.sap.show': 'Show SAP fields',
  'pm.sap.hide': 'Hide SAP fields',
  'pm.sap.toSapNote': 'These fields are transferred to SAP.',
  'pm.sap.fromSapNote': 'These fields came from SAP as shown.',
  'pm.sap.fromSapNoteMock': 'Demo data — these fields come from the mock adapter, not from SAP.',
  'pm.sap.plannedStart': 'Planned start',
  'pm.sap.plannedEnd': 'Planned end',
  // A field the portal collects but the adapter never puts on the wire (PM-SAP-FIELD-TRANSPARENCY
  // §1.1): the panel used to list those as if they were transferred.
  'pm.sap.notSent': 'not sent to SAP',
  'pm.sap.notSentNote': 'Greyed-out fields stay in the portal — they are recorded here but not transmitted to SAP.',
  'pm.status.CRTD': 'Created',
  'pm.status.REL': 'Released',
  'pm.status.CNF': 'Confirmed',
  'pm.status.TECO': 'Completed',
  'pm.status.CLSD': 'Closed (business)',
  'pm.status.PCNF': 'Partially confirmed',
  // (i) field explanations: purpose, value meaning, guidance (ui.js Row / SapPayloadPanel)
  'pm.info.orderType': 'Controls how SAP treats the order (number range, costing, authorizations). Maintenance = planned upkeep, Repair = fixing a fault. When in doubt: Repair.',
  'pm.info.plant': 'The plant being maintained. Determines stock, work centers and cost accounting. Comes from your profile scope.',
  'pm.info.workCenter': 'Who performs the work (team/trade). Drives planned costs (hourly rate) and whose "My orders" list shows the order.',
  'pm.info.equipment': 'The technical object being worked on. SAP collects the full history (past notifications, costs) of this device under its number.',
  'pm.info.priority': 'Urgency 1 (very high) to 4 (low). Affects scheduling: higher priority = earlier basic dates. Choose high only for downtime or safety risk.',
  'pm.info.problem': 'The order short text (max 40 characters in SAP). Appears in every list — be specific: "Pump P01 runs rough" beats "broken".',
  'pm.info.status': 'SAP system status: CRTD created → REL released (work can start) → CNF confirmed → TECO technically complete → CLSD business complete (no more postings).',
  'pm.info.plannedDates': 'Planned execution window. Calculated by SAP scheduling from basic date + priority; drives the overdue indicators.',
  'pm.info.maintenancePlan': 'This order was generated automatically by a maintenance plan (preventive maintenance) — date and content come from the plan, not from a person.',
  'pm.info.notification': 'The notification linked to this order. Carries the damage documentation; for this order type SAP creates it automatically.',
  // Templates (slice a)
  'pm.tpl.title': 'Templates',
  'pm.tpl.sharedTag': '(shared)',
  'pm.tpl.namePlaceholder': 'Save as template: name…',
  'pm.tpl.saveBtn': 'Save template',
  'pm.tpl.saving': 'Saving…',
  'pm.tpl.saved': 'Template saved — one tap in step 1 next time.',
  'pm.tpl.saveError': 'Could not save the template.',
  'pm.tpl.shareLabel': 'Share with all users (shared template)',
  // Preventive maintenance
  'pm.badge.preventive': 'Maintenance plan',
  'pm.detail.maintenancePlan': 'Maintenance plan',
  'pm.detail.notification': 'Notification',
  'pm.dash.show': 'Show dashboard',
  'pm.dash.hide': 'Hide dashboard',
  'pm.dash.pendingApprovals': 'Pending approvals',
  'pm.dash.openOrders': 'Open orders',
  'pm.dash.overdue': 'Overdue',
  'pm.dash.openNotifications': 'Open notifications',
  'pm.dash.byStatus': 'By status',
  'pm.dash.byType': 'By order type',
  'pm.dash.recentNotifications': 'Latest notifications',
  'pm.dash.empty': 'No data.',
  'pm.dash.mockBadge': 'Mock data',
  'pm.dash.clickHint': 'Click for list',
  'pm.week.next7': 'Next 7 days',
  'pm.week.my': 'My week',
  'pm.week.overdue': 'Overdue',
  'pm.week.today': 'Today',
  'pm.week.unscheduled': 'unscheduled',
  'pm.orders.myTitle': 'My orders',
  'pm.orders.backlogTitle': 'Order backlog',
  'pm.orders.approvalsTitle': 'Approvals',
  'pm.orders.approvalsHint': 'Orders in status “Created” — review and release.',
  'pm.orders.empty': 'No orders found.',
  'pm.orders.countSuffix': 'orders',
  // Shown when SAP's row cap cut the list — a short list must not pass as the whole plant.
  'pm.orders.truncated': 'Showing the most recent orders only — SAP returned the maximum number of rows. Narrow by plant or work centre to see the rest.',
  'pm.orders.countOne': 'order',
  'pm.detail.title': 'Order',
  // Label for the raw SAP status string (statusDetail — "REL PCNF MANC NMAT"), which the adapter
  // already returns on every read and no screen showed (PM-SAP-FIELD-TRANSPARENCY §6.3).
  'pm.detail.sapStatus': 'SAP status',
  'pm.detail.operations': 'Operations',
  // Confirmations panel: what was actually booked, and the reversal (SAP posts a counter-
  // confirmation, it never deletes - so both rows stay visible).
  'pm.conf.title': 'Booked time',
  'pm.conf.none': 'Nothing booked on this order yet.',
  'pm.conf.reverse': 'Reverse',
  'pm.conf.reversing': 'Reversing…',
  'pm.conf.reversed': 'reversed',
  'pm.conf.isReversal': 'reversal',
  'pm.conf.reverseFailed': 'SAP refused the reversal.',
  'pm.detail.components': 'Components',
  'pm.detail.confirmedShort': 'confirmed',
  'pm.detail.hours': 'Hours',
  'pm.detail.finalConfirmation': 'Final confirmation (complete the operation)',
  'pm.detail.confirmSubmit': 'Post time',
  'pm.detail.confirming': 'Posting…',
  'pm.detail.confirmPosted': 'Confirmation posted',
  'pm.detail.confirmReplayed': 'already posted — no duplicate',
  'pm.detail.release': 'Release order',
  'pm.detail.releasing': 'Releasing…',
  'pm.detail.releasedNote': 'Order released — work can start.',
  'pm.detail.teco': 'Technically complete',
  'pm.detail.tecoing': 'Completing…',
  'pm.detail.tecoNote': 'Order technically completed — the work is done.',
  'pm.detail.close': 'Complete (business)',
  'pm.detail.closing': 'Completing…',
  'pm.detail.closedNote': 'Order business completed — no further postings possible.',
  'pm.detail.closeHint': 'Final step: after business completion nothing can be posted to this order any more.',
  'pm.detail.qty': 'Quantity',
  'pm.detail.notFound': 'Order not found.',
  // Hand over components (SAP creates reservation/purchase requisition itself)
  'pm.comp.add': 'Add component',
  'pm.comp.addBtn': 'Hand over to SAP',
  'pm.comp.adding': 'Handing over…',
  'pm.comp.stockAtPlant': 'Available at plant',
  'pm.comp.shortfallHint': 'On shortfall, SAP automatically creates a purchase requisition.',
  'pm.comp.resShort': 'Res.',
  'pm.comp.prShort': 'PR',
  'pm.materials.title': 'Find material',
  'pm.materials.subtitle': 'Description, number or characteristic — e.g. “bearing” or “45 mm”.',
  'pm.materials.placeholder': 'e.g. bearing, seal, 9000012352…',
  'pm.materials.available': 'available',
  'pm.materials.bin': 'Storage bin',
  'pm.materials.outOfStock': 'Out of stock',
  'pm.materials.noResults': 'No results.',
  'pm.materials.loadingStock': 'Loading stock…',
  // Voice input (tier 1, behind the company-wide pm_features.voice flag)
  'pm.voice.loading': 'Loading voice input …',
  'pm.voice.externalAiOff': 'Voice input is not available on this instance: external AI is not enabled.',
  'pm.voice.disabledMsg': 'Voice input is disabled company-wide. Browser dictation sends audio to the browser vendor (Google/Microsoft/Apple) — enabling it must be confirmed company-wide, or a local speech model can be set up on company servers instead.',
  'pm.voice.unsupported': 'This browser does not support speech recognition (e.g. Firefox). Please use Chrome, Edge or Safari.',
  'pm.voice.start': 'Start dictation (push-to-talk)',
  'pm.voice.stop': 'Stop dictation',
  'pm.voice.listening': 'Listening',
  'pm.voice.transcribing': 'Transcribing…',
  'pm.voice.serverError': 'Local speech model is not reachable. Please inform an administrator (check the server / re-run the connection test).',
  'pm.voice.micDenied': 'Microphone access was denied — please allow it in the browser settings (or company policy).',
  'pm.voice.noMic': 'No microphone found. Please connect one and check that Windows allows apps to access the microphone (Settings → Privacy → Microphone).',
  'pm.voice.insecure': 'Microphone access only works over localhost or HTTPS — please open the app via a secure address.',
  'pm.voice.micError': 'Could not start the microphone.',
  'pm.notif.confirmTitle': 'Confirm notification',
  'pm.notif.fieldType': 'Notification type',
  'pm.notif.photoHint': 'Add photo — not active yet in the prototype',
  'pm.notif.createBtn': 'Create notification',
  'pm.notif.creating': 'Creating…',
  'pm.notif.successTitle': 'Notification created',
  'pm.notif.notifNumber': 'Notification number',
  'pm.notif.createHint': 'Created directly in SAP',

  // ── Process expansion 2026-08-09 ──
  'pm.action.notifications.label': 'Malfunction reports',
  'pm.action.notifications.sub': 'Track and process reports',
  'pm.action.preventive.label': 'Preventive maintenance',
  'pm.action.preventive.sub': 'Task lists, plans, scheduling',

  'pm.status.OSNO': 'Open',
  'pm.status.NOPR': 'In progress',
  'pm.status.NOCO': 'Completed',

  'pm.notif.title': 'Malfunction reports',
  'pm.notif.empty': 'No reports for this plant.',
  'pm.notif.equipment': 'Equipment',
  'pm.notif.number': 'Report number',
  'pm.notif.priority': 'Priority',
  'pm.notif.plant': 'Plant',
  'pm.notif.createdAt': 'Reported on',
  'pm.notif.order': 'Order',
  'pm.notif.startWork': 'Start working on it',
  'pm.notif.convertTitle': 'Create an order for this report',
  'pm.notif.convert': 'Create order',
  'pm.notif.close': 'Complete report',
  'pm.notif.notFound': 'Report not found.',
  'pm.notif.actionFailed': 'SAP rejected the action.',

  'pm.prev.title': 'Preventive maintenance',
  'pm.prev.tabPlans': 'Plans',
  'pm.prev.tabTaskLists': 'Task lists',
  'pm.prev.tabEquipment': 'Equipment',
  'pm.prev.newPlan': 'New maintenance plan',
  'pm.prev.planDescription': 'What is maintained? (e.g. Weekly pump check)',
  'pm.prev.cycleDays': 'Cycle (days)',
  'pm.prev.equipmentOptional': 'Equipment (optional)',
  'pm.prev.createPlan': 'Create and schedule in SAP',
  'pm.prev.noPlans': 'No maintenance plans for this plant yet.',
  'pm.prev.plan': 'Plan',
  'pm.prev.everyNDays': 'every {n} days',
  'pm.prev.calls': 'Calls',
  'pm.prev.cycle': 'Cycle',
  'pm.prev.startDate': 'Start date',
  'pm.prev.recentCalls': 'Recent calls',
  'pm.prev.order': 'Order',
  'pm.prev.noOrderYet': 'no order yet',
  'pm.prev.scheduleNow': 'Schedule now',
  'pm.prev.activate': 'Activate',
  'pm.prev.deactivate': 'Deactivate',
  'pm.prev.actionFailed': 'SAP rejected the action.',
  'pm.prev.newTaskList': 'New task list',
  'pm.prev.taskListDescription': 'What is done? (e.g. Monthly filter check)',
  'pm.prev.validFromHint': 'Valid from — must be ON OR BEFORE the plan start date',
  'pm.prev.startDateHint': 'Leave the start date empty for today. A date in the past creates all overdue orders immediately on scheduling — handy for demos, deliberate in production.',
  'pm.prev.validFrom': 'valid from',
  'pm.prev.operation': 'Work step',
  'pm.prev.addOperation': '+ add work step',
  'pm.prev.createTaskList': 'Create task list in SAP',
  'pm.prev.noTaskLists': 'No task lists for this plant yet.',
  'pm.prev.noTaskListApi': 'This SAP release has no task list API — create task lists in SAP (IA05).',
  'pm.prev.group': 'Group',

  'pm.equip.newTitle': 'New equipment',
  'pm.equip.description': 'Description (e.g. Pump P-100)',
  'pm.equip.costCenter': 'Cost center',
  'pm.equip.plannerGroup': 'Planner group',
  'pm.equip.costCenterHint': 'Without a cost center, orders on this equipment cannot be technically completed later (SAP IW177).',
  'pm.equip.create': 'Create in SAP',
  'pm.equip.createFailed': 'SAP rejected the equipment.',
  'pm.equip.createdAs': 'Created as',
  'pm.equip.noCostCenterWarn': 'Created WITHOUT a cost center — add one before completing orders on it.',
  'pm.equip.readingsTitle': 'Counter / measurement readings',
  'pm.equip.searchPlaceholder': 'Find equipment…',
  'pm.equip.noPoints': 'This equipment has no measuring points.',
  'pm.equip.counter': 'counter',
  'pm.equip.readingValue': 'Reading value',
  'pm.equip.recordReading': 'Record reading',
  'pm.equip.readingFailed': 'SAP rejected the reading.',
  'pm.equip.readingSaved': 'Reading saved (document {id}).',

  'pm.prev.tabCounters': 'Counters',
  'pm.cnt.title': 'Counter-based maintenance',
  'pm.cnt.intro': 'Find the asset, read its counters, book today’s reading and see how far it is from the next service.',
  'pm.cnt.unsupported': 'This SAP system does not carry the counter adapter — counters, reading history and performance-based plans are unavailable here.',
  'pm.cnt.noCounters': 'This asset has no counters.',
  'pm.cnt.point': 'Point',
  'pm.cnt.perYear': '{v} {u}/year',
  'pm.cnt.planCount': '{n} plan(s)',
  'pm.cnt.noPlans': 'no plan',
  'pm.cnt.recordTitle': 'Record reading {unit}',
  'pm.cnt.totalValue': 'New counter reading',
  'pm.cnt.deltaValue': 'Value since the last reading',
  'pm.cnt.isDifference': 'This is the amount since the last reading, not the new total',
  'pm.cnt.reader': 'Read by (name)',
  'pm.cnt.dateHint': 'The date the reading was TAKEN — not when it is typed in. A wrong date shifts the whole due forecast.',
  'pm.cnt.readingText': 'Note (optional)',
  'pm.cnt.readingFailed': 'SAP rejected the reading.',
  'pm.cnt.readingSaved': 'Reading saved (document {id}).',
  'pm.cnt.cancel': 'Reverse this reading',
  'pm.cnt.cancelFailed': 'SAP rejected the reversal.',
  'pm.cnt.cancelled': 'Reading {id} reversed.',
  'pm.cnt.alreadyCancelled': 'This reading was already reversed.',
  'pm.cnt.historyTitle': 'Reading history',
  'pm.cnt.noReadings': 'No readings recorded yet.',
  'pm.cnt.generated': 'generated',
  'pm.cnt.historyHint': 'Reversed readings stay visible, struck through — SAP keeps them for the audit trail.',
  'pm.cnt.dueTitle': 'Next service',
  'pm.cnt.cycle': 'Cycle',
  'pm.cnt.nextDueReading': 'Due at',
  'pm.cnt.remaining': 'Remaining',
  'pm.cnt.forecast': 'Expected (forecast)',
  'pm.cnt.sapScheduled': 'Scheduled by SAP',
  'pm.cnt.notScheduledYet': 'This plan has never been scheduled — no SAP date yet, only the forecast.',
  'pm.cnt.forecastHint': 'The forecast comes from the counter’s annual estimate. SAP’s own date appears once the plan is scheduled.',

  'pm.costs.title': 'Costs',
  'pm.costs.planned': 'Planned',
  'pm.costs.actual': 'Actual',
  'pm.costs.empty': 'No costs posted yet.',

  'pm.gi.title': 'Issue spare part (goods issue)',
  'pm.gi.fromComponents': 'From planned components:',
  'pm.gi.material': 'Material number',
  'pm.gi.storageLocation': 'Storage location',
  'pm.gi.post': 'Post goods issue',
  'pm.gi.failed': 'SAP rejected the goods issue.',
  'pm.gi.posted': 'Posted (material document {doc}).',
  'pm.gi.hint': 'Posting is immediate: stock at the storage location drops and the part’s value lands as actual cost on this order.',

  // (i) field explanations for the process-expansion screens
  'pm.info.notifNumber': 'The number SAP assigned to this report. Use it when talking to colleagues who work in SAP directly (IW22/IW29).',
  'pm.info.notifOrder': 'The maintenance order created for this report. The report is completed separately from the order — usually after the work is done.',
  'pm.info.cycle': 'How often SAP schedules the work. Each due date becomes a "call", and each call becomes an order on its call date.',
  'pm.info.planStart': 'The date scheduling counts from. A start in the past makes all overdue cycles due at once — SAP creates those orders immediately on the next scheduling run.',
  'pm.info.costsPlanned': 'What the work should cost, from the planned hours and planned parts — calculated by SAP when the order is created or changed.',
  'pm.info.costsActual': 'What has really been booked so far: confirmed hours and issued parts. Grows with every confirmation and goods issue; final after business completion.',

  // ── Reports (R1-R6) ──
  'pm.action.reports.label': 'Reports',
  'pm.action.reports.sub': 'Costs, breakdowns, compliance',
  'pm.rep.title': 'Reports',
  'pm.rep.tabCosts': 'Costs',
  'pm.rep.tabBreakdowns': 'Breakdowns',
  'pm.rep.tabCompliance': 'Preventive',
  'pm.rep.tabHours': 'Hours',
  'pm.rep.tabParts': 'Parts',
  'pm.rep.tabEquipment': 'Equipment file',
  'pm.rep.exportCsv': 'CSV',
  'pm.rep.planTotal': 'Planned',
  'pm.rep.actualTotal': 'Actual',
  'pm.rep.corrective': 'Corrective (actual)',
  'pm.rep.preventive': 'Preventive (actual)',
  // PMCO keeps one row set per currency. A selection spanning company codes still mixes them and
  // no exchange rate is applied — say so rather than labelling the total with one arbitrary code.
  'pm.rep.currencyMixed': 'This selection spans more than one currency. The totals are added without conversion — narrow it to one plant or company code for a comparable figure.',
  'pm.rep.byType': 'By order type',
  'pm.rep.monthlyActual': 'Actual by month',
  'pm.rep.topOrders': 'Most expensive orders',
  'pm.rep.topEquipment': 'Most expensive equipment',
  'pm.rep.orderType': 'Order type',
  'pm.rep.order': 'Order',
  'pm.rep.description': 'Description',
  'pm.rep.totalHours': 'Confirmed hours',
  'pm.rep.byWorkCenter': 'By work center',
  'pm.rep.byMonth': 'By month',
  'pm.rep.workCenter': 'Work center',
  'pm.rep.hours': 'Hours',
  'pm.rep.confirmations': 'Confirmations',
  'pm.rep.totalValue': 'Consumed value',
  'pm.rep.windowDays': 'Period (days)',
  'pm.rep.topMaterials': 'Top materials',
  'pm.rep.material': 'Material',
  'pm.rep.qty': 'Qty',
  'pm.rep.unit': 'Unit',
  'pm.rep.value': 'Value',
  'pm.rep.breakdowns': 'Breakdowns',
  'pm.rep.mttrNote': 'MTTR is computed from the {n} of {total} breakdowns whose malfunction end was recorded — maintain the end time when completing breakdown reports to improve this.',
  'pm.rep.topByBreakdowns': 'Top equipment by breakdowns',
  'pm.rep.equipment': 'Equipment',
  'pm.rep.downtime': 'Downtime (h)',
  'pm.rep.completeWindows': 'Complete records',
  'pm.rep.plans': 'Plans',
  'pm.rep.openDueCalls': 'Due without order',
  'pm.rep.inactivePlans': 'Inactive plans',
  'pm.rep.neverScheduled': 'Never scheduled',
  'pm.rep.neverScheduledOne': 'never scheduled',
  'pm.rep.perPlan': 'Per plan',
  'pm.rep.plan': 'Plan',
  'pm.rep.calls': 'Calls',
  'pm.rep.withOrder': 'With order',
  'pm.rep.nextDue': 'Next due',
  'pm.rep.openDueN': '{n} due!',
  'pm.rep.onTrack': 'on track',
  'pm.rep.openOrdersK': 'Open orders',
  'pm.rep.breakdowns12m': 'Breakdowns (12 m)',
  'pm.rep.actualCostsYear': 'Actual costs (year)',
  'pm.rep.recentOrders': 'Orders on this equipment',
  'pm.rep.recentNotifs': 'Reports on this equipment',

  // ── Real-life batch 2026-08-10 ──
  'pm.scan.open': 'Scan QR code',
  'pm.scan.hint': 'Point the camera at the QR label on the machine.',
  'pm.avail.allCovered': 'All planned parts are on stock',
  'pm.avail.short': '{n} part(s) NOT on stock',
  'pm.avail.needVsHave': 'need {need}, available {have}',
  'pm.avail.releaseHint': 'Releasing now means the work may stall waiting for parts.',
  'pm.assign.label': 'Assigned to',
  'pm.assign.nobody': 'nobody yet',
  'pm.assign.placeholder': 'Username…',
  'pm.assign.set': 'Assign',
  'pm.assign.toMe': 'To me',
  'pm.assign.recent': 'Recently used',
  'pm.assign.freeText': 'No matching user — "Assign" saves the typed name',
  // Blocked states (server /me `blocked`): role without plants / strict mode without profile
  'pm.blocked.title': 'PM access not set up yet',
  'pm.blocked.noPlants': 'Your PM role has no plant assigned yet. Ask your administrator to assign plants in user management.',
  'pm.blocked.noProfile': 'PM access requires an assigned PM profile. Ask your administrator to assign one in user management.',
  'pm.photos.title': 'Photos',
  'pm.photos.add': '+ add photo',
  'pm.photos.attached': 'Photo attached',
  'pm.photos.take': 'Take a photo of the problem (optional)',
  // A swallowed upload error looks exactly like a thumbnail that did not load, so the technician
  // walks away believing the photo is there (audit finding 05).
  'pm.photos.uploadFailed': 'The photo could not be saved — please add it again.',
  'pm.photos.tooLarge': 'The photo is larger than 5 MB and was not saved — take it again at a lower resolution.',
  'pm.codes.damageNone': 'Damage type (optional)…',
  'pm.codes.causeNone': 'Cause (optional)…',
  'pm.notif.mlfnEndLabel': 'When did the malfunction end? (feeds the reliability reports)',
  'pm.comp.prBridge': 'Purchase requisition created by SAP for the shortage — find it in the Procurement module',
  'pm.rep.pareto': 'What breaks, and why (damage/cause Pareto)',
  'pm.rep.paretoEmpty': 'No damage/cause codes recorded yet — pick them in the report wizard and this chart fills itself.',
  'pm.rep.topDamages': 'Top damage types',
  'pm.rep.topCauses': 'Top causes',
  'pm.rep.qrLabel': 'QR label',

  // Personal SAP account (attribution)
  'pm.sapacct.title': 'SAP account',
  'pm.sapacct.statusOwn': 'Your SAP changes run under your own SAP user {user} — SAP documents show your name.',
  'pm.sapacct.statusShared': 'No personal SAP user saved — changes run under the shared technical user; your name is still recorded in the portal and in the SAP activity log.',
  'pm.sapacct.username': 'SAP user (e.g. JSMITH)',
  'pm.sapacct.password': 'SAP password',
  'pm.sapacct.save': 'Verify & save',
  'pm.sapacct.remove': 'Remove',
  'pm.sapacct.saved': 'Verified against SAP and saved.',
  'pm.sapacct.removed': 'Removed — changes run under the technical user again.',
  'pm.sapacct.hint': 'Optional. The password is checked against SAP before saving, stored encrypted, and never shown again. If your SAP password changes, save it here again — a stale one locks the SAP user after a few attempts.',
};

export default pm;
